import Accordion from 'components/accordion/Accordion'
import React from 'react'
import { Col } from 'react-bootstrap'
import { IProductBase } from './IProduct'
import DescriptionReservesView from './product_list/product_list_view/DescriptionReservesView'
import ProductReservesList from './product_list/product_list_view/ProductReservesList'

export type TDescritionDisplay = 'show' | 'accordion' | 'hide'

interface IProductDescriptionProps {
  product: IProductBase
  showDescription?: TDescritionDisplay
  order?: number
  className?: string
}

const ProductDescription: React.FC<IProductDescriptionProps> = ({
  product,
  showDescription,
  order,
  className,
}) => {
  return (
    <>
      {showDescription === 'show' ? (
        <Col xs={{ span: 12, order }} className={className}>
          {product.reserves && (
            <Accordion header='Наличие' className={className}>
              <ProductReservesList reserves={product.reserves} />
            </Accordion>
          )}
          <div dangerouslySetInnerHTML={{ __html: product.info_html }} />
        </Col>
      ) : showDescription === 'accordion' && product.info_html && product.reserves ? (
        <DescriptionReservesView product={product} order={order} className={className} />
      ) : showDescription === 'accordion' && product.info_html ? (
        <Col xs={{ span: 12, order }} className='d-flex gap-5'>
          <Accordion header='Подробности' className={className}>
            <div dangerouslySetInnerHTML={{ __html: product.info_html }} />
          </Accordion>
        </Col>
      ) : showDescription === 'accordion' && product.reserves ? (
        <Col xs={{ span: 12, order }} className='d-flex gap-5'>
          <Accordion header='Наличие' className={className}>
            <ProductReservesList reserves={product.reserves} />
          </Accordion>
        </Col>
      ) : (
        <></>
      )}
    </>
  )
}
export default ProductDescription
